import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-reject-request-modal',
  templateUrl: './reject-request-modal.component.html',
  styleUrls: ['./reject-request-modal.component.scss']
})
export class RejectRequestModalComponent implements OnInit {
  rejectReason: string = null;
  @ViewChild('rejectionModal') rejectionModal;
  modalRef: NgbModalRef;
  apiRequest: Observable<any>;

  @Output() submit: EventEmitter<string> = new EventEmitter<string>();
  constructor(private modalService: NgbModal) { }


  ngOnInit(): void {
  }

  // handle the popup
  open() {
    this.modalRef = this.modalService.open(this.rejectionModal, { centered: true, size: 'md' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    this.close();
    this.submit.emit(this.rejectReason);
  }
}
